import {type PayloadAction, createSlice} from '@reduxjs/toolkit';
import type {DataLoadStatus} from 'api/types';
import {MasterLocale} from 'localization/types';
import type {RootState} from 'store/types';
import type {CodeList, CodeListId, CodeListsState} from './types';
import {mockedCodelistStatus} from '../../api/mockCodeLists/getMockCodeList';

const initialState: CodeListsState = mockedCodelistStatus;

const codelistsSlice = createSlice({
  name: 'codelists',
  initialState,
  reducers: {
    loadCodelist: (
      state,
      action: PayloadAction<{
        id: CodeListId;
        data: DataLoadStatus<CodeList>;
      }>,
    ) => {
      state[action.payload.id] = action.payload.data;
    },
    combineCodelists: (
      state,
      action: PayloadAction<{combinedId: CodeListId; partIds: CodeListId[]}>,
    ) => {
      const {combinedId, partIds} = action.payload;
      const combinedData: CodeList = {
        id: combinedId,
        codes: [],
        language: MasterLocale,
      };

      partIds.forEach(partId => {
        const partCodelist = state[partId];
        if (partCodelist?.status === 'Loaded' && partCodelist.data) {
          combinedData.codes.push(...partCodelist.data.codes);
        }
      });

      state[combinedId] = {
        status: 'Loaded',
        data: combinedData,
      };
    },
  },
});

export const {loadCodelist, combineCodelists} = codelistsSlice.actions;
export const selectCodelists = (state: RootState) => state.codelists;

export default codelistsSlice;
